/**
 * This file is auto-generated from (en.json). Do not edit directly.
 */

export const translations = {
    _base: '',
    title: 'title',
    header: {
        _base: 'header.',
        change_password: {
            _base: 'header.change_password.',
            title: 'header.change_password.title',
            form: {
                _base: 'header.change_password.form.',
                oldPassword: 'header.change_password.form.oldPassword',
                confirmPassword: 'header.change_password.form.confirmPassword',
                changed_successfully: 'header.change_password.form.changed_successfully',
                errors: {
                    _base: 'header.change_password.form.errors.',
                    required: 'header.change_password.form.errors.required',
                    changed_error: 'header.change_password.form.errors.changed_error',
                },
            },
        },
        role: 'header.role',
        logout: 'header.logout',
    },
    information: {
        _base: 'information.',
        no_user: 'information.no_user',
    },
    auth: {
        _base: 'auth.',
        welcome: 'auth.welcome',
        please_login: 'auth.please_login',
        please_select_platform: 'auth.please_select_platform',
        reset_password: 'auth.reset_password',
        go_back: 'auth.go_back',
        current_password: 'auth.current_password',
        forgot_password: 'auth.forgot_password',
        submit: 'auth.submit',
        sign_kone_sso: 'auth.sign_kone_sso',
        sign_in: 'auth.sign_in',
        go_to_login: 'auth.go_to_login',
        code: 'auth.code',
        form: {
            _base: 'auth.form.',
            sign_in: {
                _base: 'auth.form.sign_in.',
                username: 'auth.form.sign_in.username',
                password: 'auth.form.sign_in.password',
                errors: {
                    _base: 'auth.form.sign_in.errors.',
                    required: 'auth.form.sign_in.errors.required',
                    email: 'auth.form.sign_in.errors.email',
                    login_error: 'auth.form.sign_in.errors.login_error',
                    error_roles: 'auth.form.sign_in.errors.error_roles',
                    kone_email: 'auth.form.sign_in.errors.kone_email',
                },
            },
            forgot_password: {
                _base: 'auth.form.forgot_password.',
                email: 'auth.form.forgot_password.email',
                password: 'auth.form.forgot_password.password',
                code: 'auth.form.forgot_password.code',
                confirmPassword: 'auth.form.forgot_password.confirmPassword',
                email_sent_success: 'auth.form.forgot_password.email_sent_success',
                hint: 'auth.form.forgot_password.hint',
                changed_successfully: 'auth.form.forgot_password.changed_successfully',
                errors: {
                    _base: 'auth.form.forgot_password.errors.',
                    required: 'auth.form.forgot_password.errors.required',
                    sent: 'auth.form.forgot_password.errors.sent',
                    changed_error: 'auth.form.forgot_password.errors.changed_error',
                    passwordMismatch: 'auth.form.forgot_password.errors.passwordMismatch',
                    requirements: 'auth.form.forgot_password.errors.requirements',
                    minlength: 'auth.form.forgot_password.errors.minlength',
                },
            },
        },
        landing: {
            _base: 'auth.landing.',
            select: 'auth.landing.select',
            error: 'auth.landing.error',
        },
    },
    users: {
        _base: 'users.',
        title: 'users.title',
        error_add: 'users.error_add',
        error_update: 'users.error_update',
        error_delete: 'users.error_delete',
        success_added: 'users.success_added',
        success_updated: 'users.success_updated',
        success_delete: 'users.success_delete',
        delete: {
            _base: 'users.delete.',
            title: 'users.delete.title',
            text: 'users.delete.text',
        },
        dialog: {
            _base: 'users.dialog.',
            title: 'users.dialog.title',
            title_edit: 'users.dialog.title_edit',
            text: 'users.dialog.text',
            data_access: 'users.dialog.data_access',
            error: 'users.dialog.error',
            spectrio_hint: 'users.dialog.spectrio_hint',
            form: {
                _base: 'users.dialog.form.',
                firstName: 'users.dialog.form.firstName',
                lastName: 'users.dialog.form.lastName',
                email: 'users.dialog.form.email',
                countryAccess: 'users.dialog.form.countryAccess',
                tool: 'users.dialog.form.tool',
                spectrio: 'users.dialog.form.spectrio',
                elevEight: 'users.dialog.form.elevEight',
                role: 'users.dialog.form.role',
                errors: {
                    _base: 'users.dialog.form.errors.',
                    required: 'users.dialog.form.errors.required',
                    email: 'users.dialog.form.errors.email',
                    kone_email: 'users.dialog.form.errors.kone_email',
                },
            },
            invitation: {
                _base: 'users.dialog.invitation.',
                status: 'users.dialog.invitation.status',
                accepted: 'users.dialog.invitation.accepted',
                not_accepted: 'users.dialog.invitation.not_accepted',
                resend: 'users.dialog.invitation.resend',
                last_active: 'users.dialog.invitation.last_active',
                resend_success: 'users.dialog.invitation.resend_success',
                resend_error: 'users.dialog.invitation.resend_error',
            },
        },
        table: {
            _base: 'users.table.',
            firstName: 'users.table.firstName',
            lastName: 'users.table.lastName',
            email: 'users.table.email',
            tool: 'users.table.tool',
            spectrio: 'users.table.spectrio',
            elevEight: 'users.table.elevEight',
            role: 'users.table.role',
            lastLoginDate: 'users.table.lastLoginDate',
            never: 'users.table.never',
        },
        user: 'users.user',
        not_found: 'users.not_found',
    },
    elev8: {
        _base: 'elev8.',
        title: 'elev8.title',
        menu: 'elev8.menu',
        error_update: 'elev8.error_update',
        error_update_screen: 'elev8.error_update_screen',
        success_updated: 'elev8.success_updated',
        success_updated_screen: 'elev8.success_updated_screen',
        property: 'elev8.property',
        not_found: 'elev8.not_found',
        errors: 'elev8.errors',
        table: {
            _base: 'elev8.table.',
            name: 'elev8.table.name',
            address: 'elev8.table.address',
            country: 'elev8.table.country',
            id: 'elev8.table.id',
            propertyType: 'elev8.table.propertyType',
            error: 'elev8.table.error',
            types: {
                _base: 'elev8.table.types.',
                RES: 'elev8.table.types.RES',
                OFF: 'elev8.table.types.OFF',
                IND: 'elev8.table.types.IND',
            },
            sub_table: {
                _base: 'elev8.table.sub_table.',
                deviceId: 'elev8.table.sub_table.deviceId',
                ken: 'elev8.table.sub_table.ken',
                activeContract: 'elev8.table.sub_table.activeContract',
                cmsUrl: 'elev8.table.sub_table.cmsUrl',
                error: 'elev8.table.sub_table.error',
            },
        },
        details: {
            _base: 'elev8.details.',
            titles: {
                _base: 'elev8.details.titles.',
                property_details: 'elev8.details.titles.property_details',
                screen_details: 'elev8.details.titles.screen_details',
            },
            error_message: 'elev8.details.error_message',
            name: 'elev8.details.name',
            streetName: 'elev8.details.streetName',
            streetNumber: 'elev8.details.streetNumber',
            postalCode: 'elev8.details.postalCode',
            city: 'elev8.details.city',
            region: 'elev8.details.region',
            country: 'elev8.details.country',
            id: 'elev8.details.id',
            longitude: 'elev8.details.longitude',
            latitude: 'elev8.details.latitude',
            adRestrictions: 'elev8.details.adRestrictions',
            totalFloors: 'elev8.details.totalFloors',
            propertyType: 'elev8.details.propertyType',
            yearBuilt: 'elev8.details.yearBuilt',
            adAmenities: 'elev8.details.adAmenities',
            propertyNumber: 'elev8.details.propertyNumber',
            activate: {
                _base: 'elev8.details.activate.',
                success: 'elev8.details.activate.success',
                error: 'elev8.details.activate.error',
            },
            deactivate: {
                _base: 'elev8.details.deactivate.',
                success: 'elev8.details.deactivate.success',
                error: 'elev8.details.deactivate.error',
            },
            screen: {
                _base: 'elev8.details.screen.',
                activate: {
                    _base: 'elev8.details.screen.activate.',
                    success: 'elev8.details.screen.activate.success',
                    error: 'elev8.details.screen.activate.error',
                },
                deactivate: {
                    _base: 'elev8.details.screen.deactivate.',
                    success: 'elev8.details.screen.deactivate.success',
                    error: 'elev8.details.screen.deactivate.error',
                },
                title: 'elev8.details.screen.title',
                name: 'elev8.details.screen.name',
                activeContract: 'elev8.details.screen.activeContract',
                deviceId: 'elev8.details.screen.deviceId',
                androidBrand: 'elev8.details.screen.androidBrand',
                model: 'elev8.details.screen.model',
                displayType: 'elev8.details.screen.displayType',
                eloVersion: 'elev8.details.screen.eloVersion',
                language: 'elev8.details.screen.language',
                venueId: 'elev8.details.screen.venueId',
                cmsUrl: 'elev8.details.screen.cmsUrl',
                refresh: 'elev8.details.screen.refresh',
                status: 'elev8.details.screen.status',
                lastSeenAt: 'elev8.details.screen.lastSeenAt',
                contentSummary: 'elev8.details.screen.contentSummary',
                visionEnabled: 'elev8.details.screen.visionEnabled',
                referenceUrl: 'elev8.details.screen.referenceUrl',
                operatingSystem: 'elev8.details.screen.operatingSystem',
                iccid: 'elev8.details.screen.iccid',
                firmwareVersion: 'elev8.details.screen.firmwareVersion',
                connectivityMethod: 'elev8.details.screen.connectivityMethod',
                screenSize: 'elev8.details.screen.screenSize',
                resolution: 'elev8.details.screen.resolution',
                orientation: 'elev8.details.screen.orientation',
                locationDetail: 'elev8.details.screen.locationDetail',
                location: 'elev8.details.screen.location',
                url_refresh_success: 'elev8.details.screen.url_refresh_success',
                url_refresh_error: 'elev8.details.screen.url_refresh_error',
            },
        },
        dialog: {
            _base: 'elev8.dialog.',
            property: {
                _base: 'elev8.dialog.property.',
                title_edit: 'elev8.dialog.property.title_edit',
                formErrors: {
                    _base: 'elev8.dialog.property.formErrors.',
                    required: 'elev8.dialog.property.formErrors.required',
                },
            },
            screen: {
                _base: 'elev8.dialog.screen.',
                title_edit: 'elev8.dialog.screen.title_edit',
                formErrors: {
                    _base: 'elev8.dialog.screen.formErrors.',
                    required: 'elev8.dialog.screen.formErrors.required',
                },
            },
        },
    },
    management: {
        _base: 'management.',
        title: 'management.title',
        screens: {
            _base: 'management.screens.',
            title: 'management.screens.title',
            delete: {
                _base: 'management.screens.delete.',
                title: 'management.screens.delete.title',
                text: 'management.screens.delete.text',
                error: 'management.screens.delete.error',
                success: 'management.screens.delete.success',
            },
            table: {
                _base: 'management.screens.table.',
                name: 'management.screens.table.name',
                deviceId: 'management.screens.table.deviceId',
                ken: 'management.screens.table.ken',
                functionalLocation: 'management.screens.table.functionalLocation',
                activeContract: 'management.screens.table.activeContract',
                displayType: 'management.screens.table.displayType',
                eloVersion: 'management.screens.table.eloVersion',
                linked: 'management.screens.table.linked',
                error: 'management.screens.table.error',
                content: {
                    _base: 'management.screens.table.content.',
                    linked: 'management.screens.table.content.linked',
                    notLinked: 'management.screens.table.content.notLinked',
                },
            },
            details: {
                _base: 'management.screens.details.',
                error_message: 'management.screens.details.error_message',
                shadow_ken_message: 'management.screens.details.shadow_ken_message',
                update_ken: 'management.screens.details.update_ken',
                ken: 'management.screens.details.ken',
                ken_required: 'management.screens.details.ken_required',
                ken_update: {
                    _base: 'management.screens.details.ken_update.',
                    success: 'management.screens.details.ken_update.success',
                    error: 'management.screens.details.ken_update.error',
                },
                refresh: {
                    _base: 'management.screens.details.refresh.',
                    title: 'management.screens.details.refresh.title',
                    success: 'management.screens.details.refresh.success',
                    error: 'management.screens.details.refresh.error',
                },
                titles: {
                    _base: 'management.screens.details.titles.',
                    additional: 'management.screens.details.titles.additional',
                    screen: 'management.screens.details.titles.screen',
                },
                site: {
                    _base: 'management.screens.details.site.',
                    name: 'management.screens.details.site.name',
                    streetName: 'management.screens.details.site.streetName',
                    streetNumber: 'management.screens.details.site.streetNumber',
                    postalCode: 'management.screens.details.site.postalCode',
                    city: 'management.screens.details.site.city',
                    region: 'management.screens.details.site.region',
                    country: 'management.screens.details.site.country',
                    id: 'management.screens.details.site.id',
                    longitude: 'management.screens.details.site.longitude',
                    latitude: 'management.screens.details.site.latitude',
                    adRestrictions: 'management.screens.details.site.adRestrictions',
                    contractType: 'management.screens.details.site.contractType',
                    activeContract: 'management.screens.details.site.activeContract',
                    totalFloors: 'management.screens.details.site.totalFloors',
                    propertyType: 'management.screens.details.site.propertyType',
                    active_until: 'management.screens.details.site.active_until',
                    contract_start: 'management.screens.details.site.contract_start',
                    contract_end: 'management.screens.details.site.contract_end',
                },
                screen: {
                    _base: 'management.screens.details.screen.',
                    deviceId: 'management.screens.details.screen.deviceId',
                    androidBrand: 'management.screens.details.screen.androidBrand',
                    eloVersion: 'management.screens.details.screen.eloVersion',
                    model: 'management.screens.details.screen.model',
                    location: 'management.screens.details.screen.location',
                    orientation: 'management.screens.details.screen.orientation',
                    networkType: 'management.screens.details.screen.networkType',
                    cmsUrl: 'management.screens.details.screen.cmsUrl',
                    screenSize: 'management.screens.details.screen.screenSize',
                },
            },
        },
        countries: {
            _base: 'management.countries.',
            title: 'management.countries.title',
            dialog: {
                _base: 'management.countries.dialog.',
                title: {
                    _base: 'management.countries.dialog.title.',
                    edit: 'management.countries.dialog.title.edit',
                },
                form: {
                    _base: 'management.countries.dialog.form.',
                    solutionIds: 'management.countries.dialog.form.solutionIds',
                    countryCode: 'management.countries.dialog.form.countryCode',
                    name: 'management.countries.dialog.form.name',
                    subArea: 'management.countries.dialog.form.subArea',
                    errors: {
                        _base: 'management.countries.dialog.form.errors.',
                        required: 'management.countries.dialog.form.errors.required',
                    },
                },
            },
            table: {
                _base: 'management.countries.table.',
                countryCode: 'management.countries.table.countryCode',
                name: 'management.countries.table.name',
                solutionIds: 'management.countries.table.solutionIds',
            },
            success: {
                _base: 'management.countries.success.',
                add: 'management.countries.success.add',
                update: 'management.countries.success.update',
                delete: 'management.countries.success.delete',
            },
            errors: {
                _base: 'management.countries.errors.',
                add: 'management.countries.errors.add',
                update: 'management.countries.errors.update',
                delete: 'management.countries.errors.delete',
            },
            delete: {
                _base: 'management.countries.delete.',
                title: 'management.countries.delete.title',
                text: 'management.countries.delete.text',
            },
        },
    },
    footer: {
        _base: 'footer.',
        terms_conditions: 'footer.terms_conditions',
        data_privacy: 'footer.data_privacy',
        and: 'footer.and',
    },
    roles: {
        _base: 'roles.',
        Admin: 'roles.Admin',
        FacilityManager: 'roles.FacilityManager',
        Technical: 'roles.Technical',
        Support: 'roles.Support',
        User: 'roles.User',
        Viewer: 'roles.Viewer',
    },
    tools: {
        _base: 'tools.',
        title: 'tools.title',
        TOOL: 'tools.TOOL',
        SPECTRIO: 'tools.SPECTRIO',
        ELEVEIGHT: 'tools.ELEVEIGHT',
    },
    frontlines: {
        _base: 'frontlines.',
        area_code: 'frontlines.area_code',
        name: 'frontlines.name',
    },
    themes: {
        _base: 'themes.',
        light: 'themes.light',
        dark: 'themes.dark',
    },
    error_codes: {
        _base: 'error_codes.',
    },
    error_types: {
        _base: 'error_types.',
        ELEVEIGHT: 'error_types.ELEVEIGHT',
        MEDUSA: 'error_types.MEDUSA',
        KONE: 'error_types.KONE',
    },
    global: {
        _base: 'global.',
        yes: 'global.yes',
        no: 'global.no',
        search: 'global.search',
        delete: 'global.delete',
        done: 'global.done',
        open: 'global.open',
        edit: 'global.edit',
        cancel: 'global.cancel',
        filter: 'global.filter',
        add: 'global.add',
        submit: 'global.submit',
        try_again: 'global.try_again',
        options: 'global.options',
        information: 'global.information',
        success: 'global.success',
        save: 'global.save',
        continue: 'global.continue',
        okay: 'global.okay',
        clear: 'global.clear',
        logout: 'global.logout',
        unselect: 'global.unselect',
        apply: 'global.apply',
        confirmation: 'global.confirmation',
        filters: 'global.filters',
        data_saved: 'global.data_saved',
        field_mandatory: 'global.field_mandatory',
        something_went_wrong: 'global.something_went_wrong',
        view_all: 'global.view_all',
        select_all: 'global.select_all',
        close: 'global.close',
        admin: 'global.admin',
        user: 'global.user',
        version: 'global.version',
        loading: 'global.loading',
        search_failed_msg_help: 'global.search_failed_msg_help',
        email_invalid: 'global.email_invalid',
        table_report: 'global.table_report',
        data_not_found: 'global.data_not_found',
        selected_items_label: 'global.selected_items_label',
        error: 'global.error',
        show_details: 'global.show_details',
        hide_details: 'global.hide_details',
        message_details: 'global.message_details',
        deactivate: 'global.deactivate',
        activate: 'global.activate',
        synchronize: {
            _base: 'global.synchronize.',
            title: 'global.synchronize.title',
            success: 'global.synchronize.success',
            error: 'global.synchronize.error',
        },
        synchronize_full: {
            _base: 'global.synchronize_full.',
            title: 'global.synchronize_full.title',
            success: 'global.synchronize_full.success',
            error: 'global.synchronize_full.error',
        },
    },
    primeng: {
        _base: 'primeng.',
        startsWith: 'primeng.startsWith',
        contains: 'primeng.contains',
        notContains: 'primeng.notContains',
        endsWith: 'primeng.endsWith',
        equals: 'primeng.equals',
        notEquals: 'primeng.notEquals',
        noFilter: 'primeng.noFilter',
        lt: 'primeng.lt',
        lte: 'primeng.lte',
        gt: 'primeng.gt',
        gte: 'primeng.gte',
        is: 'primeng.is',
        isNot: 'primeng.isNot',
        before: 'primeng.before',
        after: 'primeng.after',
        dateIs: 'primeng.dateIs',
        dateIsNot: 'primeng.dateIsNot',
        dateBefore: 'primeng.dateBefore',
        dateAfter: 'primeng.dateAfter',
        clear: 'primeng.clear',
        apply: 'primeng.apply',
        matchAll: 'primeng.matchAll',
        matchAny: 'primeng.matchAny',
        addRule: 'primeng.addRule',
        removeRule: 'primeng.removeRule',
        accept: 'primeng.accept',
        reject: 'primeng.reject',
        choose: 'primeng.choose',
        upload: 'primeng.upload',
        cancel: 'primeng.cancel',
        weak: 'primeng.weak',
        medium: 'primeng.medium',
        strong: 'primeng.strong',
        passwordPrompt: 'primeng.passwordPrompt',
        emptyMessage: 'primeng.emptyMessage',
        emptyFilterMessage: 'primeng.emptyFilterMessage',
        fileChosenMessage: 'primeng.fileChosenMessage',
        noFileChosenMessage: 'primeng.noFileChosenMessage',
        pending: 'primeng.pending',
        chooseYear: 'primeng.chooseYear',
        chooseMonth: 'primeng.chooseMonth',
        chooseDate: 'primeng.chooseDate',
        prevDecade: 'primeng.prevDecade',
        nextDecade: 'primeng.nextDecade',
        prevYear: 'primeng.prevYear',
        nextYear: 'primeng.nextYear',
        prevMonth: 'primeng.prevMonth',
        nextMonth: 'primeng.nextMonth',
        prevHour: 'primeng.prevHour',
        nextHour: 'primeng.nextHour',
        prevMinute: 'primeng.prevMinute',
        nextMinute: 'primeng.nextMinute',
        prevSecond: 'primeng.prevSecond',
        nextSecond: 'primeng.nextSecond',
        am: 'primeng.am',
        pm: 'primeng.pm',
        searchMessage: 'primeng.searchMessage',
        selectionMessage: 'primeng.selectionMessage',
        emptySelectionMessage: 'primeng.emptySelectionMessage',
        emptySearchMessage: 'primeng.emptySearchMessage',
        dayNames: 'primeng.dayNames',
        dayNamesShort: 'primeng.dayNamesShort',
        dayNamesMin: 'primeng.dayNamesMin',
        monthNames: 'primeng.monthNames',
        monthNamesShort: 'primeng.monthNamesShort',
        dateFormat: 'primeng.dateFormat',
        firstDayOfWeek: 'primeng.firstDayOfWeek',
        today: 'primeng.today',
        weekHeader: 'primeng.weekHeader',
        fileSizeTypes: 'primeng.fileSizeTypes',
        currentPageReportTemplate: 'primeng.currentPageReportTemplate',
        aria: {
            _base: 'primeng.aria.',
            trueLabel: 'primeng.aria.trueLabel',
            falseLabel: 'primeng.aria.falseLabel',
            nullLabel: 'primeng.aria.nullLabel',
            pageLabel: 'primeng.aria.pageLabel',
            firstPageLabel: 'primeng.aria.firstPageLabel',
            lastPageLabel: 'primeng.aria.lastPageLabel',
            nextPageLabel: 'primeng.aria.nextPageLabel',
            previousPageLabel: 'primeng.aria.previousPageLabel',
        },
    },
};
